import { render, staticRenderFns } from "./ImportActivarDevolucion.vue?vue&type=template&id=53a07a09&scoped=true"
import script from "./ImportActivarDevolucion.vue?vue&type=script&lang=js"
export * from "./ImportActivarDevolucion.vue?vue&type=script&lang=js"
import style0 from "./ImportActivarDevolucion.vue?vue&type=style&index=0&id=53a07a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a07a09",
  null
  
)

export default component.exports